module.exports = __webpack_public_path__ + "img/greylimozlogli.d1f74d84.webp";